import React from 'react';

import './SelectBox.scss';
import Icon from 'Core/Components/Icon';
import TextBox from 'RLX/Forms/TextBox';

class SelectBox extends React.Component {
  constructor (props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange (e) {
    const { onChange } = this.props;
    if (typeof onChange !== 'function') return;
    const { value } = e.target;
    onChange(value)
  }

  render () {
    const { handleChange, props } = this;
    const { options, value, label, icon, disabled, className } = props;
    return !options || !Array.isArray(options) || !options.length
      ? (
        <TextBox {...props} disabled={true} />
      ) : (
        <div className={'Field SelectBox' + (className ? ' ' + className : '')}>
          {!icon ? null : <Icon fa={icon + ' SelectBox-Icon'}/>}
          {!label ? null : <label className="Field-Label">{label} &nbsp;</label>}
          <select
            value={value || ''}
            onChange={handleChange}>
            <optgroup label={label}>
              {options.map((option, index) => {
                return (
                  <option
                    key={index}
                    value={option.value}
                    children={option.text}
                  />
                );
              })}
            </optgroup>
          </select>
        </div>
      );
  }
};

export default SelectBox;



// WEBPACK FOOTER //
// ./client/RLX/Forms/SelectBox/SelectBox.jsx